import React from "react";
import { Eye, Smile, Activity, Home, Brain } from "lucide-react";
import {
  FT_ERKENNUNGSMERKMALE,
  ERKENNUNGSMERKMAL_ORDER,
} from "@/data/fokustypErkennungsmerkmale";

// Sprint 11.6 Block 2 — Task 3: 5 Erkennungsmerkmale pro FT
// Alltagstauglich. Pro Kategorie 1 Icon + Label + Body-Text.
// Inhalte: /app/frontend/src/data/fokustypErkennungsmerkmale.js

const ICONS = {
  verhalten: Activity,
  mimik: Smile,
  reaktion: Eye,
  umgebung: Home,
  erste_verarbeitung: Brain,
};

export default function FokustypErkennungsmerkmale({ fokustyp, accent = "#4563BB" }) {
  const ft = (fokustyp || "").toLowerCase();
  const data = FT_ERKENNUNGSMERKMALE[ft];
  if (!data) return null;
  return (
    <section
      className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 dark:border-slate-700 dark:bg-slate-800/60"
      data-testid="steckbrief-erkennungsmerkmale"
    >
      <p className="text-xs font-bold uppercase tracking-widest" style={{ color: accent }}>
        So erkennst du sie
      </p>
      <h3 className="mt-1 text-xl sm:text-2xl font-bold text-slate-900 dark:text-slate-100">
        5 Erkennungsmerkmale
      </h3>
      <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
        Alltagstauglich — direkt im nächsten Gespräch nutzbar.
      </p>
      <ul className="mt-5 space-y-4">
        {ERKENNUNGSMERKMAL_ORDER.map(({ key, label }) => {
          const Icon = ICONS[key] || Activity;
          const body = data[key];
          return (
            <li
              key={key}
              className="flex items-start gap-3"
              data-testid={`erkennungsmerkmal-${key}`}
            >
              <span
                className="shrink-0 w-9 h-9 rounded-lg inline-flex items-center justify-center"
                style={{ background: `${accent}14`, color: accent }}
                aria-hidden="true"
              >
                <Icon className="w-4 h-4" />
              </span>
              <div className="flex-1">
                <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">{label}</p>
                <p className="mt-0.5 text-sm text-slate-700 dark:text-slate-300 leading-relaxed">{body}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
